module.exports = __webpack_public_path__ + "img/Premium Settings.7cf37706.png";